import React from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Notification } from '../../../../../../common/notification'
import { DefaultVsicName } from '../../../DefaultVsicName'
import { GDP_TAB } from '../../constant'
import { SourceLabel } from '../../sourceLabel'
import { selectNominalIds, selectRealIds } from '../store/slice'
import { Tab } from './Tab'
import { TableNominalGDP } from './TableNominalGDP'
import { TableRealGDP } from './TableRealGDP'
import classes from './index.module.scss'

export const GDPTableContent = ({ tab, isDynamicReport, column }) => {
  const realIds = useSelector(selectRealIds)
  const nominalIds = useSelector(selectNominalIds)

  const ids = tab === GDP_TAB.REAL_GDP.key ? realIds : nominalIds

  if (!ids?.length && isDynamicReport) {
    return <Notification isDynamicReport={isDynamicReport} />
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div>
          <Translate
            value="industryOverview.macroeconomics.GDP_GDP_GROWTH_RATE"
            className="fw600"
          />
        </div>
        {!isDynamicReport && <Tab />}
      </div>
      <DefaultVsicName isDynamicReport={isDynamicReport} />

      {tab === GDP_TAB.REAL_GDP.key ? (
        <TableRealGDP isDynamicReport={isDynamicReport} column={column} />
      ) : (
        <TableNominalGDP isDynamicReport={isDynamicReport} column={column} />
      )}
      <SourceLabel isRight />
    </div>
  )
}
